module.exports = __webpack_public_path__ + "static/FY_2022_Financial_reporting_Audit_report-3766fa2bd474497991800b9bd35ffb30.pdf";